import { render } from "./DesignComponent.vue?vue&type=template&id=46ab26c8"
import script from "./DesignComponent.vue?vue&type=script&lang=js"
export * from "./DesignComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__